var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGenesisVideoLogo = function SvgGenesisVideoLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.65 33.162c1.406.181 2.926 1.757 4.574 3.972.251.422.502.858.754 1.308 3.525 6.369 6.236 15.425 11.236 19.45 16.742 13.483 32.255-28.427 50.69 3.014a37.29 37.29 0 0 0 .142-41.647 37.34 37.34 0 0 0-38.544-15.83C17.628 6.478 6.084 18.226 3.302 33.144c.105-.008.21-.008.314 0l.034.018Z",
    fill: "url(#genesisVideoLogo_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.674 40.025c0 20.605 16.713 37.308 37.33 37.308 20.616 0 37.33-16.703 37.33-37.308 0-5.498-4.99-21.22-17.369-21.22-13.902 0-19.253 35.62-34.837 35.62-9.396 0-16.463-21.481-21.813-21.274a44.798 44.798 0 0 0-.641 6.874Z",
    fill: "url(#genesisVideoLogo_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.985 38.446c-.251-.45-.502-.886-.754-1.308-1.787-2.39-3.427-4.055-4.928-3.994 1.712-.068 3.597 2.193 5.682 5.302Z",
    fill: "url(#genesisVideoLogo_svg__c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.65 33.162c1.617.223 3.393 2.386 5.335 5.276-.251-.45-.503-.885-.754-1.307-1.655-2.212-3.175-3.784-4.581-3.969Z",
    fill: "url(#genesisVideoLogo_svg__d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.616 33.159Z",
    fill: "url(#genesisVideoLogo_svg__e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.616 33.159Z",
    fill: "url(#genesisVideoLogo_svg__f)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m70.84 61.027.072-.102-.072.102Z",
    fill: "url(#genesisVideoLogo_svg__g)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m70.84 61.027.072-.102-.072.102Z",
    fill: "url(#genesisVideoLogo_svg__h)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.222 57.892c-5-4.025-7.71-13.077-11.236-19.45-1.942-2.898-3.714-5.057-5.336-5.276h-.034a1.97 1.97 0 0 0-.313 0 37.293 37.293 0 0 0 7.976 30.695 37.338 37.338 0 0 0 28.724 13.472h1.441l.754-.037.377-.023.754-.06.34-.03c.347-.034.697-.072 1.04-.117h.03c.355-.046.71-.098 1.064-.151l.32-.053.754-.128.377-.068.724-.15.328-.072c.327-.073.652-.15.973-.234h.053c.34-.086.679-.18 1.018-.279l.306-.09.709-.219.346-.113.69-.233.313-.11c.307-.11.613-.224.917-.343l.056-.022c.325-.128.646-.26.966-.396l.279-.12.678-.306.32-.15.653-.317.29-.143c.285-.143.566-.29.845-.441l.068-.038c.304-.166.605-.335.901-.508l.253-.151.64-.377.295-.185.61-.377.269-.177.773-.531.071-.05c.282-.198.56-.401.834-.61l.226-.173.592-.464.267-.214.559-.464.24-.203c.235-.201.466-.405.695-.61l.075-.069c.252-.23.503-.466.754-.704l.2-.193c.181-.175.36-.352.536-.53l.237-.242.498-.524.215-.234c.203-.223.404-.448.603-.674l.08-.09c.225-.252.447-.514.663-.788l.173-.215c.159-.196.316-.393.472-.592l.207-.271c.146-.19.29-.383.43-.577l.192-.263c.171-.24.34-.48.505-.724l.072-.102c-18.45-31.531-33.959 10.371-50.7-3.112Z",
    fill: "url(#genesisVideoLogo_svg__i)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.222 57.892c-5-4.025-7.71-13.077-11.236-19.45-1.942-2.898-3.714-5.057-5.336-5.276h-.034a1.97 1.97 0 0 0-.313 0 37.293 37.293 0 0 0 7.976 30.695 37.338 37.338 0 0 0 28.724 13.472h1.441l.754-.037.377-.023.754-.06.34-.03c.347-.034.697-.072 1.04-.117h.03c.355-.046.71-.098 1.064-.151l.32-.053.754-.128.377-.068.724-.15.328-.072c.327-.073.652-.15.973-.234h.053c.34-.086.679-.18 1.018-.279l.306-.09.709-.219.346-.113.69-.233.313-.11c.307-.11.613-.224.917-.343l.056-.022c.325-.128.646-.26.966-.396l.279-.12.678-.306.32-.15.653-.317.29-.143c.285-.143.566-.29.845-.441l.068-.038c.304-.166.605-.335.901-.508l.253-.151.64-.377.295-.185.61-.377.269-.177.773-.531.071-.05c.282-.198.56-.401.834-.61l.226-.173.592-.464.267-.214.559-.464.24-.203c.235-.201.466-.405.695-.61l.075-.069c.252-.23.503-.466.754-.704l.2-.193c.181-.175.36-.352.536-.53l.237-.242.498-.524.215-.234c.203-.223.404-.448.603-.674l.08-.09c.225-.252.447-.514.663-.788l.173-.215c.159-.196.316-.393.472-.592l.207-.271c.146-.19.29-.383.43-.577l.192-.263c.171-.24.34-.48.505-.724l.072-.102c-18.45-31.531-33.959 10.371-50.7-3.112Z",
    fill: "url(#genesisVideoLogo_svg__j)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.222 57.892c-5-4.025-7.71-13.077-11.236-19.45-1.618-2.815-3.714-5.057-5.336-5.276h-.034a1.97 1.97 0 0 0-.313 0 37.293 37.293 0 0 0 7.976 30.695 37.338 37.338 0 0 0 28.724 13.472h1.441l.754-.037.377-.023.754-.06.34-.03c.347-.034.697-.072 1.04-.117h.03c.355-.046.71-.098 1.064-.151l.32-.053.754-.128.377-.068.724-.15.328-.072c.327-.073.652-.15.973-.234h.053c.34-.086.679-.18 1.018-.279l.306-.09.709-.219.346-.113.69-.233.313-.11c.307-.11.613-.224.917-.343l.056-.022c.325-.128.646-.26.966-.396l.279-.12.678-.306.32-.15.653-.317.29-.143c.285-.143.566-.29.845-.441l.068-.038c.304-.166.605-.335.901-.508l.253-.151.64-.377.295-.185.61-.377.269-.177.773-.531.071-.05c.282-.198.56-.401.834-.61l.226-.173.592-.464.267-.214.559-.464.24-.203c.235-.201.466-.405.695-.61l.075-.069c.252-.23.503-.466.754-.704l.2-.193c.181-.175.36-.352.536-.53l.237-.242.498-.524.215-.234c.203-.223.404-.448.603-.674l.08-.09c.225-.252.447-.514.663-.788l.173-.215c.159-.196.316-.393.472-.592l.207-.271c.146-.19.29-.383.43-.577l.192-.263c.171-.24.34-.48.505-.724l.072-.102c-18.45-31.531-33.959 10.371-50.7-3.112Z",
    fill: "url(#genesisVideoLogo_svg__k)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.413 40.835c0-2.755-1.587-4.447-4.24-4.447-2.197 0-4.22 1.779-4.22 4.523a4.405 4.405 0 0 0 4.507 4.578c1.714 0 2.928-.7 3.617-1.586l-1.379-1.376a2.657 2.657 0 0 1-2.14.972c-1.195 0-2.261-.821-2.318-1.952h6.146a8.28 8.28 0 0 0 .027-.712Zm-6.12-.874a1.858 1.858 0 0 1 1.918-1.692c1.327 0 1.884.885 1.918 1.692h-3.836ZM42.948 45.23H40.63v-8.597h2.261v.807a2.977 2.977 0 0 1 2.367-1.018c1.978 0 3.2 1.508 3.2 3.392v5.427H46.14v-5.016c0-.912-.528-1.711-1.587-1.711-.991 0-1.605.784-1.605 1.778v4.937ZM63.347 40.044c-.524-.132-.78-.192-1.199-.302-.5-.135-.799-.339-.799-.72 0-.46.445-.787 1.078-.787a2.747 2.747 0 0 1 2.013.965l1.447-1.436a4.45 4.45 0 0 0-3.324-1.364c-1.997 0-3.467 1.25-3.467 2.807 0 1.281.754 2.05 2.457 2.529.584.166.852.218 1.266.331.543.147.908.415.908.818 0 .403-.35.72-1.168.72-1.047 0-1.79-.686-2.197-1.044l-1.41 1.39a4.843 4.843 0 0 0 3.58 1.553c2.262 0 3.445-1.424 3.445-2.819.008-1.27-.867-2.193-2.63-2.641ZM67.18 45.23v-8.597h2.317v8.581l-2.318.015ZM58.044 40.835c0-2.755-1.586-4.447-4.24-4.447-2.196 0-4.22 1.779-4.22 4.523a4.406 4.406 0 0 0 4.522 4.586c1.715 0 2.928-.701 3.618-1.587l-1.38-1.375a2.656 2.656 0 0 1-2.14.972c-1.194 0-2.26-.822-2.317-1.952h6.146c-.004-.11.011-.4.011-.72Zm-6.12-.87a1.858 1.858 0 0 1 1.919-1.693c1.326 0 1.884.886 1.918 1.693h-3.837ZM70.812 39.196c0 1.281.754 2.05 2.457 2.529.584.165.852.218 1.266.331.543.147.909.415.909.818 0 .403-.35.72-1.169.72-1.047 0-1.79-.686-2.197-1.044l-1.409 1.39a4.843 4.843 0 0 0 3.58 1.553 3.633 3.633 0 0 0 2.781-1.078c.12-1.021.196-2.054.23-3.101-.422-.57-1.157-1.003-2.204-1.267-.524-.131-.78-.192-1.199-.301-.501-.136-.799-.34-.799-.72 0-.46.445-.787 1.078-.787a2.75 2.75 0 0 1 2.024.96l1.066-1.058c0-.257-.03-.517-.049-.754a4.549 4.549 0 0 0-2.902-.999c-1.99 0-3.463 1.251-3.463 2.808ZM27.474 36.633v.844a3.58 3.58 0 0 0-2.638-.994c-2.22 0-4.205 1.929-4.205 4.503a4.323 4.323 0 0 0 4.224 4.503 3.448 3.448 0 0 0 2.551-1.074v.754c0 1.47-1.1 2.291-2.468 2.291a3.599 3.599 0 0 1-2.465-1.078l-1.507 1.508a5.472 5.472 0 0 0 4.081 1.715c3.203 0 4.673-2.507 4.673-4.715v-8.257h-2.246Zm-2.299 6.682a2.333 2.333 0 1 1 2.333-2.333 2.333 2.333 0 0 1-2.329 2.348l-.004-.015ZM68.332 32.073a1.59 1.59 0 1 1-.007 3.181 1.59 1.59 0 0 1 .007-3.18Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.283
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "genesisVideoLogo_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(56.7942 0 0 56.7616 3.31 34.704)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#F69322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9262A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "genesisVideoLogo_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(67.8839 0 0 67.8448 5.734 46.56)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAF3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAAA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F89D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F68639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F47738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F37237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#F26535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#EE4E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EA2F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9262A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "genesisVideoLogo_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1023.69 0 0 1023.1 118.014 650.197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAF3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAAA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F89D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F68639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F47738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F37237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#F26535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#EE4E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EA2F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9262A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "genesisVideoLogo_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(803.639 0 0 803.177 74.574 480.985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#F69322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9262A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "genesisVideoLogo_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(47.1839 0 0 .94243 7.509 33.684)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#F69322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9262A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "genesisVideoLogo_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(56.4358 0 0 1.12722 10.025 33.88)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAF3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAAA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F89D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F68639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F47738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F37237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#F26535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#EE4E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EA2F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9262A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "genesisVideoLogo_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(12.9246 0 0 18.3676 72.375 72.792)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAF3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAAA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F89D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F68639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F47738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F37237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#F26535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#EE4E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EA2F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9262A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "genesisVideoLogo_svg__h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(17.6833 0 0 25.1303 75.994 54.91)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F47738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F26830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15B28"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "genesisVideoLogo_svg__i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(10280.8 0 0 10274.9 598.833 3782.6)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#F69322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9262A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "genesisVideoLogo_svg__j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(12296.4 0 0 12289.3 955.633 5172.29)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAF3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAAA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F89D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F68639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F47738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F37237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#F26535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#EE4E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EA2F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9262A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "genesisVideoLogo_svg__k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(16836.2 0 0 16826.4 11715.7 4244.65)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F47738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F26830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15B28"
  })))));
};

export default SvgGenesisVideoLogo;